import { Injectable } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { event } from "jquery";

@Injectable({
  providedIn: "root",
})
export class HighlightService {
  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.clear();
      }
    });
    window.addEventListener("beforeunload", () => {
      this.clear();
    });
  }

  private storageKey = "highlightMap";

  // Get current page key 
  private getPageKey(): string {
    const hash = window.location.hash;
    return hash ? hash.replace(/^#/, "") : window.location.pathname;
  }

  private getMap(): Record<string, number> {
    const stored = sessionStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : {};
  }

  private saveMap(map: Record<string, number>): void {
    sessionStorage.setItem(this.storageKey, JSON.stringify(map));
  }

  // Set highlight ID for current page
  set(id: number): void {
    const map = this.getMap();
    const pageKey = this.getPageKey();
    map[pageKey] = id;
    this.saveMap(map);
    console.log(`Set highlight ID for [${pageKey}]:`, id);
  }

  get(): number | null {
    const map = this.getMap();
    const pageKey = this.getPageKey();
    const id = map[pageKey] ?? null;
    // console.log(`Get highlight ID for [${pageKey}]:`, id);
    return id;
  }

  // Check if the given ID is highlighted on the current page
  is(id: number): boolean {
    const match = this.get() === id;
    // console.log(`Is ID ${id} highlighted on [${this.getPageKey()}]?`, match);
    return match;
  }

  clear(): void {
    const map = this.getMap();
    const pageKey = this.getPageKey();
    delete map[pageKey];
    this.saveMap(map);
    console.log(`Cleared highlight for [${pageKey}]`);
  }

  logAll(): void {
    const map = this.getMap();
    console.log("All page highlight map:", map);
  }
}
